import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface GuarantorRatingsFieldProps {}

export const GuarantorRatingsField: React.FC<GuarantorRatingsFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ guarantor_ratings: string }>()

  return (
    <FormField
      name="guarantor_ratings"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Guarantor Ratings</FormLabel>
              <FormError />
            </div>
            <Input
              {...register('guarantor_ratings')}
              placeholder={"Enter the guarantor's ratings"}
            />
          </FormItem>
        )
      }}
    />
  )
}
